import { gql } from '@apollo/client';

export const GET_ITEM_REQUEST_SERVICE_LIST = gql`
  query GetItemRequestServiceList(
    $domainCategoryIds: String!
    $categoryId: Int
    $subCategoryId: Int
    $page: Int!
    $size: Int!
  ) {
    getItemRequestServiceList(
      domainCategoryIds: $domainCategoryIds
      categoryId: $categoryId
      subCategoryId: $subCategoryId
      page: $page
      size: $size
    ) {
      count
      currentPage
      message
      nextPage
      prevPage
      result {
        itemRequestServiceID
        itemRequestServiceTitle
        itemRequestServiceDescription
        uploadPath
        thumbNailPath
        domainCategoryID
        subCategoryID
        categoryID
      }
      success
      totalPages
    }
  }
`;

// Update the TypeScript interfaces
export interface ItemRequestService {
  itemRequestServiceID: string;
  itemRequestServiceTitle: string;
  itemRequestServiceDescription: string;
  uploadPath: string;
  thumbNailPath: string;
  domainCategoryID: string;
  subCategoryID: string;
  categoryID: string;
}

export interface GetItemRequestServiceListResponse {
  count: number;
  currentPage: number;
  message: string;
  nextPage: number | null;
  prevPage: number | null;
  result: ItemRequestService[];
  success: boolean;
  totalPages: number;
}

export interface GetItemRequestServiceListData {
  getItemRequestServiceList: GetItemRequestServiceListResponse;
}

// Variables interface for the query - Updated types
export interface GetItemRequestServiceListVariables {
  domainCategoryIds: string;
  categoryId?: number | null;  // Changed from string to number
  subCategoryId?: number | null;  // Changed from string to number
  page: number;
  size: number;
}